import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AreaAccessService } from '../services/area-access.service';


@Directive({
    selector: '[areaAccess]',
    standalone: false
})
export class AreaAccessDirective {

  private hasView = false;

  @Input() set areaAccess(path: string) {
    this.setElementView(path);
  }

  @Input() areaAccessElse?: TemplateRef<unknown>;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly areaAccessService: AreaAccessService
  ) { }

  private setElementView(path: string): void {
    if (!path) {
      if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }

      return;
    }

    this.areaAccessService.checkForPermission(path).subscribe(hasPermission => {
      if (hasPermission && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (this.areaAccessElse) {
        this.viewContainer.createEmbeddedView(this.areaAccessElse);
        this.hasView = true;
      } else if (!hasPermission && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });

  }

}
